let ppInitHostUrl = '';

// export const replaceSensitiveContent = (html: HTMLElement) => {
//   const div = document.createElement('div');
//   div.append(...Array.from(html.cloneNode(true).childNodes));

//   const replaceTextWithAsterisk = (text: string) => {
//     return text.replace(/\w/g, '*');
//   };

//   const lookupSensitiveContent = (nodes: NodeListOf<ChildNode>) => {
//     // biome-ignore lint/complexity/noForEach: <explanation>
//     nodes.forEach((node) => {
//       if ((node as HTMLElement)?.attributes?.length) {
//         // biome-ignore lint/complexity/noForEach: <explanation>
//         Array.from((node as HTMLElement).attributes).forEach((attr) => {
//           // eslint-disable-next-line
//           attr.value = replaceTextWithAsterisk(attr.value);
//         });
//       }

//       if (node.hasChildNodes()) {
//         lookupSensitiveContent(node.childNodes);
//         return;
//       }

//       // eslint-disable-next-line
//       node.textContent = replaceTextWithAsterisk(node.textContent);
//     });
//   };

//   lookupSensitiveContent(div.childNodes);

//   return div;
// };

export const setPTPInitData = () => {
  ppInitHostUrl = window.location.href;
};

export const getPTPInitData = () => {
  return {
    ppInitHostUrl,
  };
};
